import React, { useContext, useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { multiStepContext } from "../StepContext";
import thiredPage from "../Style/ThiredPage.css";
const ThiredStep = () => {


  const {
    setCurrentStep,
    setUserData,
    userData,
    user,
    submitData,
    setThiredPageData,
    thiredPageData,
    thiredPageUser,
  } = useContext(multiStepContext);

  const Name1 = "Online Service";
  const option1 = 1;

  const Name2 = "Larger Storege ";
  const option2 = 2;

  const Name3 = "Customizable profile";
  const option3 = 3;




  return (
    <div>
      <div className="section1 ">
        <h2>Pick Add-ons</h2>
        <p>Add ons help enhanch your gamming exprience</p>
      </div>

      <div className="section2 adds ">
        <div className="checkbox">
          <div className="form-check check">
            <input
              onClick={(e) => setUserData({ ...userData, option1, Name1 })}
              value={userData[option1]}
              className="form-check-input position-static"
              type="checkbox"
              id="blankCheckbox"
              aria-label="..."
            />
            <p>{Name1}</p>
            <span>Access to multiplayer games</span>
          </div>
        </div>
        <div className="rate">
          <p>+${option1}/mo</p>
        </div>
      </div>

      <div className="section2 adds">
        <div className="checkbox">
          <div className="form-check check">
            <input
              onClick={(e) => setUserData({ ...userData, option2, Name2 })}
              value={userData[option2]}
              className="form-check-input position-static"
              type="checkbox"
              id="blankCheckbox"
              aria-label="..."
            />
            <p>{Name2}</p>
            <span>Extra 1TB of Cloud Save</span>
          </div>
        </div>
        <div className="rate">
          <p>+${option2}/mo</p>
        </div>
      </div>

      <div className="section2 adds">
        <div className="checkbox">
          <div className="form-check check">
            <input
              onClick={(e) => setUserData({ ...userData, option3, Name3 })}
              value={userData[option3]}
              className="form-check-input position-static"
              type="checkbox"
              id="blankCheckbox"
              aria-label="..."
            />
            <p>{Name3}</p>
            <span>Custom theme on your profile</span>
          </div>
        </div>
        <div className="rate">
          <p>+${option3}/mo</p>
        </div>
      </div>


      <div className="btngroup">
        <div className="">
          <Button
            style={{ marginRight: "10px" }}
            onClick={() => setCurrentStep(2)}
            variant="contained"
            color="primary"
          >
            Back
          </Button>
        </div>

        <div className="">
          <Button
            onClick={() => {
              setCurrentStep(4);
              user();
            }}
            variant="contained"
            color="primary"
          >
            Next Step
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ThiredStep;
